export const SHOW = "prevenx/modal/SHOW"
export const DISMISS = "prevenx/modal/DISMISS"